/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./OtherSources.vue?vue&type=template&id=49840faf&scoped=true&"
import script from "./OtherSources.vue?vue&type=script&lang=js&"
export * from "./OtherSources.vue?vue&type=script&lang=js&"
import style0 from "./OtherSources.vue?vue&type=style&index=0&id=49840faf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49840faf",
  null
  
)

export default component.exports